import { useMemo, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getInventoryTypes } from 'Reducers/Inventory/actions'
import { getClients } from 'Reducers/Clients/actions'

const optionsSortFunc = (a, b) => {
  if (a.label < b.label) return -1
  if (a.label > b.label) return 1
  return 0
}
export function useQuery() {
  return new URLSearchParams(window.location.search)
}

export function useTypeAndClientHashmap() {
  const dispatch = useDispatch()
  const { clients, inventoryTypes } = useSelector(state => ({
    clients: state.clients.clientsList,
    inventoryTypes: state.inventory.inventoryTypes,
  }))

  useEffect(() => {
    dispatch(getClients())
    dispatch(getInventoryTypes())
  }, [])

  const clientsHashmap = useMemo(
    () =>
      clients.reduce((acc, t) => {
        acc[t.id] = t
        return acc
      }, {}),
    [clients],
  )

  const typesHashmap = useMemo(
    () =>
      inventoryTypes.reduce((acc, t) => {
        acc[t.id] = t
        return acc
      }, {}),
    [inventoryTypes],
  )

  return { clientsHashmap, typesHashmap }
}

export function useTypeAndClientOptions() {
  const { clientsHashmap, typesHashmap } = useTypeAndClientHashmap()

  const clientOptions = useMemo(() => {
    const clientOptions = Object.keys(clientsHashmap)
      .map(id => ({ value: id, label: clientsHashmap[id].name }))
      .sort(optionsSortFunc)

    return [{ value: null, label: 'All' }, ...clientOptions]
  }, [clientsHashmap])

  const typeOptions = useMemo(() => {
    const typeOptions = Object.keys(typesHashmap)
      .map(id => ({ value: id, label: typesHashmap[id].name }))
      .sort(optionsSortFunc)

    return [{ value: null, label: 'All' }, ...typeOptions]
  }, [typesHashmap])

  return { typeOptions, clientOptions }
}
